var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertIconMinor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bell-minor",
    d: "M11.375,8.743h0V4.375a4.375,4.375,0,0,0-8.75,0V8.743L0,10.5v.875H14V10.5Z",
    fill: "#00a1b4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bell-minor",
    d: "M8.5,17.5a1.75,1.75,0,0,0,1.75-1.75H6.75A1.75,1.75,0,0,0,8.5,17.5Z",
    transform: "translate(-1.5 -3.5)",
    fill: "#00a1b4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertIconMinor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert-icon-minor.65c638eb0f4abc69aa9e811e3c2bbf49.svg";